import { CATALOG_TAGS_TABLE_COLUMN_WIDTH } from '@/components/ReadersTable/catalogTagsColumnWidth';

/** Собственные ширины колонок каталога чтецов (только px). */
const READERS_CATALOG_COLUMN_WIDTHS = {
  menu: '50px',
  state: '200px',
  name: '230px',
  studio: '200px',
  legal_entity: '200px',
  contacts: '200px',
  reader_price: '180px',
  demo: '135px',
  /** Две иконки (файлы, заметки) — по аналогии с projects menu_combo, без PDF */
  menu_combo: '96px',
  tags: CATALOG_TAGS_TABLE_COLUMN_WIDTH,
} as const;

export const READERS_GRID_COLUMNS = [
  READERS_CATALOG_COLUMN_WIDTHS.menu,
  READERS_CATALOG_COLUMN_WIDTHS.state,
  READERS_CATALOG_COLUMN_WIDTHS.name,
  READERS_CATALOG_COLUMN_WIDTHS.studio,
  READERS_CATALOG_COLUMN_WIDTHS.legal_entity,
  READERS_CATALOG_COLUMN_WIDTHS.reader_price,
  READERS_CATALOG_COLUMN_WIDTHS.contacts,
  READERS_CATALOG_COLUMN_WIDTHS.demo,
  READERS_CATALOG_COLUMN_WIDTHS.menu_combo,
  READERS_CATALOG_COLUMN_WIDTHS.tags,
].join(' ');

export const READER_COLUMNS = [
  {
    id: 'menu',
    title: '',
    cellClassName: 'projects-table__cell projects-table__cell_icon',
  },
  {
    id: 'state',
    title: 'Сотрудничество',
    cellClassName:
      'projects-table__cell projects-table__cell_base readers-table-catalog__cell_state',
  },
  {
    id: 'name',
    title: 'Имя',
    /** Без projects-table__cell_base: как колонка «Название» в ProjectsTable (`name` не в BASE_COLUMN_IDS), иначе .projects-table__cell_base ломает рост высоты многострочного блока имени */
    cellClassName: 'projects-table__cell projects-table__cell_name',
  },
  {
    id: 'studio',
    title: 'Студия',
    cellClassName: 'projects-table__cell projects-table__cell_contractors',
  },
  {
    id: 'legal_entity',
    title: 'Юрлицо',
    cellClassName: 'projects-table__cell projects-table__cell_contractors',
  },
  {
    id: 'reader_price',
    title: 'Стоимость',
    cellClassName: 'projects-table__cell projects-table__cell_base',
  },
  {
    id: 'contacts',
    title: 'Контакты',
    cellClassName: 'projects-table__cell projects-table__cell_combo projects-table__cell_base',
  },
  {
    id: 'demo',
    title: 'Демо',
    cellClassName: 'projects-table__cell projects-table__cell_performers',
  },
  {
    id: 'menu_combo',
    title: '',
    cellClassName: 'projects-table__cell projects-table__cell_icon projects-table__cell_menu-combo',
  },
  {
    id: 'tags',
    title: 'Теги',
    cellClassName:
      'projects-table__cell projects-table__cell_base readers-table-catalog__cell_tags',
  },
] as const;

export function getVisibleReaderColumns(showReaderPrice: boolean) {
  if (showReaderPrice) return READER_COLUMNS;
  return READER_COLUMNS.filter((column) => column.id !== 'reader_price');
}

export function getReadersGridColumns(showReaderPrice: boolean): string {
  if (showReaderPrice) return READERS_GRID_COLUMNS;
  return [
    READERS_CATALOG_COLUMN_WIDTHS.menu,
    READERS_CATALOG_COLUMN_WIDTHS.state,
    READERS_CATALOG_COLUMN_WIDTHS.name,
    READERS_CATALOG_COLUMN_WIDTHS.studio,
    READERS_CATALOG_COLUMN_WIDTHS.legal_entity,
    READERS_CATALOG_COLUMN_WIDTHS.contacts,
    READERS_CATALOG_COLUMN_WIDTHS.demo,
    READERS_CATALOG_COLUMN_WIDTHS.menu_combo,
    READERS_CATALOG_COLUMN_WIDTHS.tags,
  ].join(' ');
}

export const READER_CATALOG_SUMMARY_KEYS = [
  'name',
  'studio',
  'legal_entity',
  'reader_price',
  'contacts',
  'demo',
  'files',
  'notes',
  'tags',
] as const;
